export default {
  studio308: {
    name: 'Studio 308',
    description: 'Studio 308 is a boutique creation company. We dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.',
    links: {
      website: 'https://studio308.co',
      github: 'https://github.com/studio308',
      twitter: 'https://twitter.com/_studio308',
      instagram: '',
      linkedin: '',
      google_plus: '',
      facebook: ''
    }
  },
  links: [
    {
      name: 'Home',
      to: 'home'
    },
    {
      name: 'Services',
      to: 'services'
    },
    {
      name: 'Projects',
      to: 'projects'
    },
    {
      name: 'Team',
      to: 'team'
    },
    {
      name: 'About',
      to: 'about'
    },
    {
      name: 'Contact',
      to: 'contact'
    }
  ],
  projects: [
    {
      title: 'Film Club',
      alias: 'filmclub',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [
        {
          title: 'Web',
          alias: 'web',
          description: ''
        },
        {
          title: 'Mobile',
          alias: 'mobile',
          description: ''
        }
      ]
    },
    {
      title: 'Howie',
      alias: 'howie',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [
        {
          title: 'Web',
          alias: 'web',
          description: ''
        },
        {
          title: 'Mobile',
          alias: 'mobile',
          description: ''
        }
      ]
    },
    {
      title: 'Bone Loss Calculator',
      alias: 'bone_loss_calculator',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [
        {
          title: 'Web',
          alias: 'web',
          description: ''
        },
        {
          title: 'Mobile',
          alias: 'mobile',
          description: ''
        }
      ]
    },
    {
      title: 'Jonny Pickett Website',
      alias: 'jonny_pickett_website',
      description: '',
      links: {
        website: 'https://jonnypickett.com'
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [
        {
          title: 'Web',
          alias: 'web',
          description: ''
        }
      ]
    },
    {
      title: 'Whitnee Wright Portfolio Website',
      alias: 'whitnee_wright_portfolio_website',
      description: '',
      links: {
        website: 'https://whitneewright.com'
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [
        {
          title: 'Web',
          alias: 'web',
          description: ''
        }
      ]
    }
  ],
  services: [
    {
      title: 'Design',
      hash: '#design',
      description: 'Have an idea yet don\'t know exactly how it will work? We will take your idea and transform it from the beautifully intangible collection of thoughts into a concrete plan of action ready to be executed.'
    },
    {
      title: 'Build',
      hash: '#build',
      description: 'It\'s one thing to have a plan of how something can be accomplished. It\'s another thing entirely to accomplish it. And we do that. With our breadth of knowledge in web and mobile development coupled with our project management experience, your product will be done on time.'
    },
    {
      title: 'Deploy',
      hash: '#deploy',
      description: 'It\'s the moment you\'ve been waiting for. Everything is built, and you love it. Getting your product out into the world can sometimes be just as difficult, if not more so, as building it. We will ensure that your mobile app gets to it\'s proper store and your web app gets out to that wonderful world wide web as smoothly as can be.'
    },
    {
      title: 'Maintain',
      hash: '#maintain',
      description: 'Let\'s face it. Things change. We will help you cope with it (as long as the change we\'re talking about pertains to your mobile or web products). We will help you when you need to change the content or structure of your product, or your product needs to change to keep up with the ever changing technical landscape.'
    },
    {
      title: 'Repair',
      hash: '#repair',
      description: 'Sometimes you\'re not happy with what you\'ve got. Let us know. We\'ll take a look and find a way to turn those frowns upside down. Yeah, we do that, too.'
    }
  ],
  statuses: [
    {
      title: 'In Analysis',
      alias: 'in_analysis',
      description: '',
      projects: [
        {
          title: 'Film Club',
          alias: 'filmclub',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Analysis',
            alias: 'in_analysis',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            },
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            }
          ]
        },
        {
          title: 'Howie',
          alias: 'howie',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Analysis',
            alias: 'in_analysis',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            },
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            }
          ]
        }
      ]
    },
    {
      title: 'In Progress',
      alias: 'in_progress',
      description: '',
      projects: [
        {
          title: 'Bone Loss Calculator',
          alias: 'bone_loss_calculator',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            },
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        },
        {
          title: 'Jonny Pickett Website',
          alias: 'jonny_pickett_website',
          description: '',
          links: {
            website: 'https://jonnypickett.com'
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        },
        {
          title: 'Whitnee Wright Portfolio Website',
          alias: 'whitnee_wright_portfolio_website',
          description: '',
          links: {
            website: 'https://whitneewright.com'
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Completed',
      alias: 'completed',
      description: '',
      projects: []
    }
  ],
  types: [
    {
      title: 'Web',
      alias: 'web',
      description: '',
      projects: [
        {
          title: 'Film Club',
          alias: 'filmclub',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Analysis',
            alias: 'in_analysis',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            },
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            }
          ]
        },
        {
          title: 'Howie',
          alias: 'howie',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Analysis',
            alias: 'in_analysis',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            },
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            }
          ]
        },
        {
          title: 'Bone Loss Calculator',
          alias: 'bone_loss_calculator',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            },
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        },
        {
          title: 'Jonny Pickett Website',
          alias: 'jonny_pickett_website',
          description: '',
          links: {
            website: 'https://jonnypickett.com'
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        },
        {
          title: 'Whitnee Wright Portfolio Website',
          alias: 'whitnee_wright_portfolio_website',
          description: '',
          links: {
            website: 'https://whitneewright.com'
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Mobile',
      alias: 'mobile',
      description: '',
      projects: [
        {
          title: 'Film Club',
          alias: 'filmclub',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Analysis',
            alias: 'in_analysis',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            },
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            }
          ]
        },
        {
          title: 'Howie',
          alias: 'howie',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Analysis',
            alias: 'in_analysis',
            description: ''
          },
          types: [
            {
              title: 'Web',
              alias: 'web',
              description: ''
            },
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            }
          ]
        },
        {
          title: 'Bone Loss Calculator',
          alias: 'bone_loss_calculator',
          description: '',
          links: {
            website: ''
          },
          status: {
            title: 'In Progress',
            alias: 'in_progress',
            description: ''
          },
          types: [
            {
              title: 'Mobile',
              alias: 'mobile',
              description: ''
            },
            {
              title: 'Web',
              alias: 'web',
              description: ''
            }
          ]
        }
      ]
    },
    {
      title: 'Game',
      alias: 'game',
      description: '',
      projects: []
    }
  ],
  teammates: [
    {
      full_name: 'Jonny Pickett',
      description: 'Jonny Pickett is pretty great.',
      github_username: 'jonnypickett',
      email: 'jonathan@studio308.co',
      links: {
        website: 'https://jonnypickett.com',
        github: 'https://github.com/jonnypickett',
        twitter: 'https://twitter.com/jonnypickett',
        instagram: 'https://www.instagram.com/jonnypickett',
        linkedin: 'https://www.linkedin.com/in/jonathanpickett',
        google_plus: 'https://plus.google.com/u/2/108228820594969320563',
        facebook: ''
      }
    },
    {
      full_name: 'Jordan Pickett',
      description: 'Jordan Pickett is pretty great, too.',
      github_username: 'jordanepickett',
      email: 'jordan@studio308.co',
      links: {
        website: '',
        github: 'https://github.com/jordanepickett',
        twitter: '',
        instagram: '',
        linkedin: 'https://www.linkedin.com/in/jordan-pickett-70a241123',
        google_plus: 'https://plus.google.com/u/2/114383669972380804911',
        facebook: ''
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/storage/data.js